import React, { use, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { H6, Image, LI, P, UL } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'
import { settingIconData } from '../../../Data/Layout/RightHeader'
import SvgIcon from '../../../Utils/CommonComponents/CommonSvgIcons'
import { getUserSessionDetails, logout } from '../../../services/common.service'
import { toast } from 'react-toastify'
import { Button } from 'reactstrap'

export default function UserWrap() {
    const [open, setOpen] = useState(false)
    const toggle = () => {
        setOpen(!open)
    }

    const navigate=useNavigate();
    const performLogout = async() => {
        const logoutSuccess=await logout();
        if(logoutSuccess)
            navigate('/login');
        else
            toast.error('Logout failed. Please try again.');
    }

    return (
        <li className="profile-nav custom-dropdown">
            <div className="user-wrap" onClick={toggle}>
                <div className="user-img">
                    {/* <Image src={dynamicImage(`profile.png`)} alt="user" /> */}
                </div>
                <div className="user-content">
                    <H6>{`${getUserSessionDetails()?.firstname} ${getUserSessionDetails()?.lastname}` }</H6>
                    <P className="mb-0">{getUserSessionDetails()?.role?.toUpperCase()}<i className="fa-solid fa-chevron-down" /></P>
                </div>
            </div>
            <div className={`custom-menu overflow-hidden ${open ? 'show' : ''}`}>
                <UL className="profile-body simple-list">
                    {settingIconData.map((item) => (
                        <LI className="d-flex" key={item.id}>
                            <SvgIcon className='svg-color' iconId={item.icon} />
                            {/* <span className="ms-2">{item.text}</span> */}
                            <Link className="ms-2" to={`${process.env.PUBLIC_URL}/${item.link}`}>
                                {item.text}
                            </Link>
                        </LI>
                    ))}
                    <LI className="d-flex" onClick={logout}>
                        <SvgIcon className='svg-color' iconId='Login' />
                        <Button className="ms-2" onClick={performLogout} color='link' style={{ padding: 0, textDecoration: 'none' }}>
                            {'Log Out'}
                        </Button>
                    </LI>
                </UL>
            </div>
        </li>
    )
}